import React from 'react';

import { Button, Card, CardHeader, TextField } from '@material-ui/core';
import { Component } from 'react';
import { connect } from 'react-redux';
import { changePassword, updatePassword } from '../../redux/actions';
import { setError, setSuccess } from '../../redux/actions/MessageAction';
import { baseStyles } from '../../theme/style';
import Alerts from '../common/Alerts';

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      oldPassword: '',
      password: '',
      confirmPassword: '',
      token: '',
    };
  }

  componentDidMount() {
    console.log('ResetPassword componentDidMount');
    console.log(this.props.history.location);
    if (this.props.history.location.search !== '') {
      let data = this.props.history.location.search.split('?')[1];
      let email = data.split('&')[1]?.split('=')[1];
      let token = data.split('&')[0]?.split('=')[1];
      console.log(email, token);
      this.setState({ email, token });
    }
  }

  handlePasswordChange() {
    const { password, confirmPassword, email, token, oldPassword } = this.state;
    if (password === confirmPassword) {
      if (!token) {
        this.props.updatePassword(password, oldPassword);
      } else {
        this.props.changePassword(token, email, password);
      }
    } else {
      alert('password are not match');
    }
  }
  onChange = ({ name, value }) => {
    this.setState({ [name]: value });
    this.props.setError('');
    this.props.setSuccess('');
  };

  render() {
    console.log(this.state);
    const { password, confirmPassword, email, token, oldPassword } = this.state;
    const title = token ? 'Change Password' : 'Create a new password';
    let content = (
      <div style={baseStyles.container}>
        <Card style={baseStyles.loginBox}>
          <CardHeader title={title} />
          <div style={baseStyles.form}>
            {token && (
              <TextField placeholder="email" fullWidth={true} name="email" onChange={(e) => this.onChange(e.target)} value={email} type="text" />
            )}
            {!token && (
              <TextField
                placeholder="old Passwrod"
                fullWidth={true}
                name="oldPassword"
                onChange={(e) => this.onChange(e.target)}
                value={oldPassword}
                type="password"
              />
            )}
            <TextField
              placeholder="Password"
              fullWidth={true}
              name="password"
              onChange={(e) => this.onChange(e.target)}
              value={password}
              type="password"
            />
            <TextField
              placeholder="confirm Password"
              fullWidth={true}
              name="confirmPassword"
              onChange={(e) => this.onChange(e.target)}
              value={confirmPassword}
              type="password"
            />

            <Button variant="contained" color="primary" onClick={this.handlePasswordChange.bind(this)}>
              Update Password
            </Button>
            <Alerts />
          </div>
        </Card>
      </div>
    );

    return <div>{content}</div>;
  }
}

const styles = {
  error: {
    fontWeight: 'bold',
    color: '#f7183a',
  },
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    registerError: state.login.registerError,
  };
};

const mapDispatchToProps = {
  updatePassword,
  setError,
  setSuccess,
  changePassword,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
